/* React */
import React from "react";

/* Ionic */
import { IonCard } from "@ionic/react";

/* Stylesheet */
import styles from "./SettingsWrapper.module.scss";

/* Interfaces */
interface SettingsWrapperProps {
  children: React.ReactNode;
}

const SettingsWrapper: React.FC<SettingsWrapperProps> = ({
  children,
}) => {
  return (
    <IonCard className={styles.settings_wrapper}>
      {children}
    </IonCard>
  );
};

export default SettingsWrapper;
